import React from 'react';
import { Card } from 'react-bootstrap';
import { Line } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import { formatNumber } from '../../reports/reportHelper';

const EmissionTrendChart = ({ trend }) => {
  const { labels, datasets } = trend;
  const { t } = useTranslation(); 

  return (
    <Card className="mb-4">
      <Card.Body>
        <div className="font-weight-bold mb-1">
          {t('Emission Intensity Over Time')}
        </div>

        <div style={{ height: 280 }}>
          <Line
            data={{
              labels,
              datasets: [
                {
                  label: datasets.emissionIntensity.label,
                  data: datasets.emissionIntensity.data,
                  borderColor: '#22C55E',
                  fill: false,
                  spanGaps: true,
                },
                {
                  label: datasets.sectorBenchmark.label,
                  data: datasets.sectorBenchmark.data,
                  borderColor: '#3B82F6',
                  borderDash: [6, 6],
                  fill: false,
                },
              ],
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,
              legend: { display: false },
              scales: {
                yAxes: [{
                  scaleLabel: {
                    display: true,
                    labelString: 'tCO2e/£M',
                  },
                }],
              },
              tooltips: {
                filter: function (tooltipItem, data) {
                  let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
                  return value !== 0;
                },
                callbacks: {
                  label: (tooltipItem, data) => {
                    const { label } = data.datasets[tooltipItem.datasetIndex];
                    const value = formatNumber(tooltipItem.value);
                    return t('{{label}}: {{number}} tCO2e/£M', { label, number: value });
                  },
                }
              },
            }}
          />
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', gap: 24, marginTop: 8 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <svg width="32" height="12">
              <line x1="0" y1="6" x2="32" y2="6" stroke="#22C55E" strokeWidth="2" />
            </svg>
            <span style={{ fontSize: 12 }}>{datasets.emissionIntensity.label}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <svg width="32" height="12">
              <line x1="0" y1="6" x2="32" y2="6" stroke="#3B82F6" strokeWidth="2" strokeDasharray="6,4" />
            </svg>
            <span style={{ fontSize: 12 }}>{datasets.sectorBenchmark.label}</span>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default EmissionTrendChart;
